<template>
    <div class="components-container" id="homeMainBody" style="margin: 0;">
        <!-- 页头 -->
        <div class="headerMain">
            <!-- logo -->
            <div class="top_logo inlineRight">
<!--                <img :src="logoImg" alt="logo"/>-->
            </div>
            <div class="right_box inlineRight text-right">
                <div>
                    <!--                    <div class="customButton">-->
                    <!--                        <div class="username" @click="returnMenu">返回</div>-->
                    <!--                        <div class="userImg"></div>-->
                    <!--                    </div>-->
                    <div class="customButton">
                        <div class="username">{{ userName }}</div>
                        <div class="userImg"><img :src="userImg" alt="exit" height="100%"/></div>
                    </div>
                    <div v-if="pwdChangeVisible" class="customButton" @click="changePsw">
                        <div class="username">修改密码</div>
                        <div class="iconImg"><img :src="pswImg" height="100%"/></div>
                    </div>
                    <div class="customButton" @click="logout">
                        <div class="username">退出</div>
                        <div class="iconImg"><img :src="exitImg" alt="exit" height="100%"/></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 中心 -->
        <div class="mainMain" :style="defaultHeight">
            <!-- 中心背景 -->
            <!-- <div class="mainBg">
                <div class="topbg">
                    <img :src="bgTopImg" alt="" width="100%">
                </div>
                <div class="bottomBg">
                    <img :src="bgBottomImg" alt="" width="100%">
                    <div class="titleBg">
                        <img :src="bgTitleImg" alt="" width="100%">
                    </div>
                </div>
            </div> -->
            <!-- 中心内容 -->
            <div class="mainNr">
                <!-- pc -->
                <!-- 走马灯 点击 不自动播放 不需要底部的指示器 两边箭头总是显示-->
                <el-carousel class="pcBox" trigger="click" :autoplay="false" :arrow="arrowState" :indicator-position="indicatorState">
                    <el-carousel-item class="itemOne"
                                      v-for="itemIndex in userSystemCards.length <= pageCardNum? 1: parseInt(userSystemCards.length / pageCardNum) + 1"
                                      :key="itemIndex">
                        <div class="card-box">
                            <!-- 菜单列表 -->
                            <div v-if="parseInt(index/pageCardNum) === itemIndex-1"
                                 class="cardBg inlineRight"
                                 v-for="(item,index) in userSystemCards" :key="index">
                                <div class="cardMain" @click="showSubsystem(item.code, item.name)">
                                    <div class="cardImg">
                                        <img :src="item.img" alt="">
                                    </div>
                                    <div class="cardName text-center">
                                        <h3>{{ item.name }}</h3>
                                        <small>{{ item.Ename }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <!-- 手机端 -->
                <div class="phoneBox">
                    <!-- 菜单列表 -->
                    <div class="cardBg inlineRight" v-for="(item,index) in card" :key="index">
                        <div class="cardMain" @click="showSubsystem(item.code, item.name)">
                            <div class="cardImg">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="cardName text-center">
                                <h3>{{ item.name }}</h3>
                                <small>{{ item.Ename }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 页脚 -->
        <div class="footerMain">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <!--            地址：上海市虹口区三门路661号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
            <!--            电话：021-31236158&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
            <!--            邮编：200439-->
            <!-- <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2023002704号</a> -->
        </div>
    </div>
</template>
<script>
import {globalConfig} from 'static/config';
import firstPageMenu from './firstPageMenu'

export default {
    data() {
        return {
            userName: null,
            subSystemAuth: null,
            logoImg: require("image/homePage/logo.png"), //logo
            exitImg: require("image/homePage/exitImg.png"), //退出
            bgTopImg: require('image/homePage/mainTop.jpg'), //中间背景上部分
            bgBottomImg: require('image/homePage/mainBottom.jpg'), //中间背景下部分
            bgTitleImg: require('image/homePage/mainTitle.png'), //中间背景标题
            userImg: require('image/homePage/userImg.png'), //用户标签
            pswImg: require('image/homePage/pswImg.png'), //用户标签
            defaultHeight: {
                height: "", //判断中间内容的高度
                background: '',
            },
            card: [],
            systemCards: [
                // {
                //     code: 'M1',
                //     name: "基础信息管理",
                //     Ename: "Information Management",
                //     img: require('image/homePage/jcxx.png'),
                // },
                // {
                //     code: 'M9',
                //     name: "学生管理系统",
                //     Ename: "Student Management System",
                //     img: require('image/homePage/xsgl.png'),
                // },
                // {
                //     code: 'M2',
                //     name: "教学管理系统",
                //     Ename: "Educational Management System",
                //     img: require('image/homePage/jxgl.png'),
                // },
                // {
                //     code: 'M3',
                //     name: "排课管理系统",
                //     Ename: "Course Scheduling Management System",
                //     img: require('image/homePage/pkgl.png'),
                // },
                // {
                //     code: 'M4',
                //     name: "选修课管理系统",
                //     Ename: "Elective Course Management System",
                //     img: require('image/homePage/xxk.png'),
                // },
                // {
                //     code: 'M5',
                //     name: "考务管理系统",
                //     Ename: "Examination Management System",
                //     img: require('image/homePage/kwgl.png'),
                // },
                // {
                //     code: 'M6',
                //     name: "成绩管理系统",
                //     Ename: "Result Management System",
                //     img: require('image/homePage/cjgl.png'),
                // },
                // {
                //     code: 'M7',
                //     name: "外考管理系统",
                //     Ename: "Outside The Exam Management System",
                //     img: require('image/homePage/wkgl.png'),
                // },
                // {
                //     code: 'M8',
                //     name: "评教管理系统",
                //     Ename: "Teaching Evaluation Management System",
                //     img: require('image/homePage/pjgl.png'),
                // },
                // {
                //     code: 'M10',
                //     name: "实习管理系统",
                //     Ename: "Specialty Practice Management System",
                //     img: require('image/homePage/cjcx.png'),
                // },
                // {
                //     code: 'M11',
                //     name: "竞赛管理系统",
                //     Ename: "Specialty Practice Management System",
                //     img: require('image/homePage/beiyong_5.png'),
                // },
                {
                    code: 'M0',
                    name: "系统管理",
                    Ename: "System Management",
                    img: require('image/homePage/xtgl.png'),
                },
                // {
                //     code: 'M98',
                //     name: "教师服务中心",
                //     Ename: "Teacher service Center",
                //     img: require('image/homePage/xsswzx.png'),
                // },
                // {
                //     code: 'M99',
                //     name: "学生服务中心",
                //     Ename: "Student service Center",
                //     img: require('image/homePage/xsswzx.png'),
                // },
                // {
                //     code: 'M12',
                //     name: "教研管理",
                //     Ename: "message Center",
                //     img: require('image/homePage/xsswzx.png'),
                // },
                {
                    code: 'M13',
                    name: "职后教育-成人教育",
                    Ename: "message Center",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M14',
                    name: "职后教育-技能认定",
                    Ename: "Skill Recognition",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M15',
                    name: "职后教育-技能培训",
                    Ename: "message Center",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M16',
                    name: "外聘教师管理",
                    Ename: "message Center",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M17',
                    name: "学生管理",
                    Ename: "message Center",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M18',
                    name: "职后教育-数据汇总",
                    Ename: "data Summary",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M19',
                    name: "师生信息服务",
                    Ename: "data Summary",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M20',
                    name: "基础信息",
                    Ename: "data Summary",
                    img: require('image/homePage/xsswzx.png'),
                },
                {
                    code: 'M100',
                    name: "消息通知",
                    Ename: "data Summary",
                    img: require('image/homePage/xsswzx.png'),
                },
            ],
            userSystemCards: [],
            pageCardNum: 12,
            arrowState: 'never',
            indicatorState: 'none',
            pwdChangeVisible: false,
        };
    },
    filters: {
        // 转换数据
    },
    mounted() {
        localStorage.removeItem('mode');
        localStorage.removeItem('subsystemId');
        localStorage.removeItem('subsystemName');
        localStorage.removeItem('expandMenuName');
        //徐毅骏 20241122 模块查询位置更换
        this.$store.state.permission.addRouters = [];
        this.$store.state.permission.routers = [];
        this.pwdChangeVisible = !globalConfig.CASSWITCH;
    },
    async created() {
        //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
        window.addEventListener("resize", this.getHeight);
        this.loadSystemCard();
        this.getHeight();
        await this.queryUserInfo().then((result) => {
            this.queryUserModule();
        });
    },
    methods: {
        returnMenu() {
            this.$router.push({path: '/firstPage'});
        },
        loadSystemCard() {
            switch (this.$route.query.name) {
                case 'fullTime':
                    this.systemCards = [];
                    this.systemCards = this.systemCards.concat(firstPageMenu.fullTime);
                    break;
                case 'education':
                    this.systemCards = [];
                    this.systemCards = this.systemCards.concat(firstPageMenu.education);
                    break;
                case 'other':
                    this.systemCards = [];
                    this.systemCards = this.systemCards.concat(firstPageMenu.other);
                    break;
                default:
                    break;
            }
        },
        getHeight() {
            if ($(window).width() < 750) {
                this.defaultHeight.height = window.innerHeight - 180 + "px";
                this.defaultHeight.background = 'url(' + require('image/homePage/newsBg.jpg') + ') no-repeat  center';
            } else {
                this.defaultHeight.height = window.innerHeight - 160 + "px";
                this.defaultHeight.background = 'url(' + require('image/homePage/newsBg.jpg') + ') no-repeat';
            }
        },
        queryUserInfo() {
            return new Promise((resolve, reject) => {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;
                    resolve();
                    if (userInfo) {
                        this.userName = userInfo.name;
                    } else {

                    }
                }).catch((err) => {
                    console.log(err);
                });
            })
        },
        queryUserModule() {
            this.$api.system.basic.queryUserModule({}).then((res) => {
                this.subSystemAuth = res.data.data;
                this.filterCards();
            }).catch((err) => {
                console.log(err);
            });
        },
        filterCards() {
            for (let i = 0; i < this.systemCards.length; i++) {
                if (this.subSystemAuth && this.subSystemAuth.indexOf(this.systemCards[i].code) > -1) {
                    this.userSystemCards.push(this.systemCards[i]);
                }
            }

            if (this.userSystemCards.length > this.pageCardNum) {
                this.arrowState = 'hover';
                this.indicatorState = '';
            }
        },
        // verifyAuth(sysCode){
        //     return this.subSystemAuth && this.subSystemAuth.indexOf(sysCode) > -1;
        // },
        showSubsystem(sid, sname) {
            localStorage.setItem('mode', 3);
            localStorage.setItem('subsystemId', sid);
            localStorage.setItem('subsystemName', sname);

            //设置默认展开的菜单
            if (sid === 'M0') {
                localStorage.setItem('expandMenuName', '系统管理');
            } else if (sid === 'M4') {
                localStorage.setItem('expandMenuName', '选修管理');
            } else if (sid === 'M5') {
                localStorage.setItem('expandMenuName', '考务管理');
            } else if (sid === 'M7') {
                localStorage.setItem('expandMenuName', '考级考证管理');
            } else if (sid === 'M8') {
                localStorage.setItem('expandMenuName', '评教管理');
            } else if (sid === 'M9') {
                localStorage.setItem('expandMenuName', '学生管理');
            } else if (sid === 'M10') {
                localStorage.setItem('expandMenuName', '实习管理');
            } else if (sid === 'M11') {
                localStorage.setItem('expandMenuName', '竞赛管理');
            } else if (sid === 'M98') {
                localStorage.setItem('expandMenuName', '教师服务中心');
            } else if (sid === 'M99') {
                localStorage.setItem('expandMenuName', '学生服务中心');
            }

            this.$router.push('/index');
            location.reload();
        },
        changePsw() {
            window.open(globalConfig.PSWURL, '_self');
        },
        logout() {
            this.$api.system.basic.userLogout({}).then((res) => {
                if (res.status == 200) {
                    localStorage.clear();

                    if (globalConfig.CASSWITCH) {
                        // let routeUrl = this.$router.resolve({
                        //     path: "/casLogoutAll"
                        // });
                        window.open(globalConfig.CASURL + '/logout?service=' + encodeURIComponent(globalConfig.DOMIN), '_self');
                    } else {
                        location.reload();
                    }
                } else {
                    this.$message.error('登出失败，网络异常');
                }
            }).catch((err) => {
                console.log(err);
                this.$message.error('登出失败，网络异常');
            });
        },
    }
};
</script>
<!-- #2f79c4 深蓝 #6da1d6 logo蓝 #ABCAEB 浅蓝 #ffffff 白色-->
<style>
#homeMainBody {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow: hidden;
}

#homeMainBody .inlineRight {
    display: inline-block;
    float: left;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

/*--------------------------------------- 头部 ---------------------------------------*/
#homeMainBody .headerMain {
    height: 100px;
    position: relative;
    background-color: #2f79c4;
    z-index: 2;
}

/* logo区域 */
#homeMainBody .headerMain .top_logo {
    height: 100%;
    width: 40%;
    padding: 8px 0 8px 10px;
}

#homeMainBody .headerMain .top_logo img {
    height: 90%;
    margin-top: 5px;
}

/* 右侧用户名区域 */
#homeMainBody .headerMain .right_box {
    height: 100%;
    width: 60%;
    color: #fff;
}

#homeMainBody .headerMain .right_box div {
    height: 100%;
    position: relative;
}

#homeMainBody .headerMain .right_box .userImg {
    height: 50px;
    background: #fff;
    border-radius: 50%;
    padding: 8px;
    margin-right: 7px;
    float: right;
    top: 50%;
    transform: translateY(-50%);
}

#homeMainBody .headerMain .right_box .username {
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    margin-right: 10px;
    float: right;
    top: 50%;
    transform: translateY(-50%);
}

#homeMainBody .headerMain .right_box .iconImg {
    height: 50px;
    padding: 8px;
    margin-right: 15px;
    cursor: pointer;
    float: right;
    top: 50%;
    transform: translateY(-50%);
}

/*--------------------------------------- 中心 ---------------------------------------*/
#homeMainBody .mainMain {
    background-size: cover !important;
    position: relative;
}

#homeMainBody .phoneBox {
    display: none;
}

/* 背景 */
#homeMainBody .mainMain .mainBg {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

#homeMainBody .mainMain .mainBg .topbg {
    height: 50%;
    background: #f5f6f0;
    position: relative;
}

#homeMainBody .mainMain .mainBg .topbg img {
    position: absolute;
    bottom: 0;
}

#homeMainBody .mainMain .mainBg .titleBg {
    position: absolute;
    bottom: 0;
}

/* 内容 */
#homeMainBody .mainMain .mainNr {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

/* 走马灯高度 */
#homeMainBody .mainMain .mainNr .el-carousel--horizontal,
#homeMainBody .mainMain .mainNr .el-carousel__container {
    height: 100%;
}

/* 左右箭头 */
#homeMainBody .mainMain .mainNr .el-carousel__arrow {
    background: transparent;
    height: auto;
    width: auto;
}

#homeMainBody .mainMain .mainNr .el-carousel__arrow i:hover {
    color: #ABCAEB;
}

#homeMainBody .mainMain .mainNr .el-carousel__arrow i {
    font-size: 7em;
    color: #6da1d6;
}

/* 指示器 */
#homeMainBody .mainMain .mainNr .el-carousel__indicator--horizontal button {
    width: 50px;
    height: 10px;
    border-radius: 5px;
    background: #ABCAEB;
}

#homeMainBody .mainMain .mainNr .el-carousel__indicator--horizontal.is-active button {
    width: 80px;
    height: 10px;
    background: #2f79c4;
}

#homeMainBody .mainMain .mainNr .itemOne {
    padding: 4em 7em;
}

#homeMainBody .mainMain .card-box {
    height: 100%;
    width: 100%;
}

#homeMainBody .mainMain .cardBg {
    width: 25%;
    height: 33.3%;
    padding: 1em;
}

#homeMainBody .mainMain .cardMain {
    height: 100%;
    width: 100%;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 10px #e0e0e0;
}

#homeMainBody .mainMain .cardMain:hover {
    cursor: pointer;
    transform: translateY(-5px);
}

.mainMain .cardMain .cardImg {
    height: 65%;
    text-align: center;
}

#homeMainBody .mainMain .cardMain .cardImg img {
    height: 90%;
    margin-top: 5%;
}

#homeMainBody .mainMain .cardMain .cardName h3 {
    margin: 0;
    padding: 10px 5px;
    color: #6da1d6;
    font-size: 2vh;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: inline-block;
}

#homeMainBody .mainMain .cardMain .cardName small {
    overflow: hidden;
    padding: 0 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: inline-block;
    color: #b3b3b3;
}

/*--------------------------------------- 页脚 ---------------------------------------*/
#homeMainBody .footerMain {
    background-color: #2f79c4;
    line-height: 60px;
    height: 60px;
    text-align: center;
    z-index: 2;
}

#homeMainBody .footerMain {
    color: #fff;
}

/*--------------------------------------- 响应式 ---------------------------------------*/
@media all and (min-width: 750px) and (max-width: 1000px) {
    #homeMainBody .mainMain .cardBg {
        width: 33.3%;
        height: 25%;
    }

    #homeMainBody .mainMain .cardMain .cardImg {
        height: 55%;
    }
}

/*------------------- 高度不够缩小图片 -------------------*/
@media all and (max-height: 1000px) {
    .mainMain .cardMain .cardImg {
        height: 55%;
    }
}

/*------------------- 手机端 -------------------*/
@media all and (max-width: 750px) {

    /* 隐藏pc */
    #homeMainBody .pcBox {
        display: none;
    }

    /* 头部 */
    #homeMainBody .headerMain {
        height: 120px;
    }

    #homeMainBody .headerMain .top_logo {
        height: 68px;
        width: 100%;
        text-align: center;
    }

    #homeMainBody .headerMain .right_box {
        height: 36px;
        width: 100%;
        margin-top: 10px;
    }

    #homeMainBody .headerMain .right_box div {
        height: 36px;
    }

    #homeMainBody .headerMain .right_box .username {
        height: 36px;
        line-height: 36px;
    }

    #homeMainBody .headerMain .right_box .userImg {
        height: 36px;
    }

    #homeMainBody .headerMain .right_box .iconImg {
        height: 36px;
    }

    /* 显示手机端 */
    #homeMainBody .phoneBox {
        display: block;
        height: 100%;
        width: 100%;
        /* border:1px red solid; */
        overflow-x: hidden;
        overflow-y: auto;
    }

    #homeMainBody .mainMain .cardBg {
        width: 33.3%;
        height: 180px;
        padding: 8px;
    }

    #homeMainBody .mainMain .cardMain .cardImg {
        height: 50%;
    }
}

@media all and (max-width: 400px) {
    #homeMainBody .headerMain .top_logo img {
        width: 100%;
        height: auto;
    }
}

.customButton {
    display: inline-block;
    cursor: pointer;
}

.customButton:hover {
    color: #ff6146;
}

.customButton .iconImg {
    margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// homePage.vue?646587c4